import {
  ActiveFileType,
  usePaymentDetail,
} from '@/components/InvoiceReportDetailDrawer/context/PaymentDetailContext';
import { FileInfoDrawerContainer } from '@/components/InvoiceReportDetailDrawer/FileInfoDrawer';
import { useFileInfoDrawerContext } from '@/components/InvoiceReportDetailDrawer/FileInfoDrawer/context/FileInfoDrawerContext';
import { Loading } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, ReactNode, Suspense, useCallback, useState } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export type BusinessDocumentFetcherRenderProps = {
  businessDocumentId: string;
  onFileNameLoaded: (fileName: string) => void;
};

type Props = {
  children: (props: BusinessDocumentFetcherRenderProps) => ReactNode;
};

const FallbackLoading: FC = () => (
  <div className={cx('loading-container')}>
    <Loading size='large' color='default' />
  </div>
);

export const BusinessDocumentDrawerShell: FC<Props> = ({ children }) => {
  const { open } = useFileInfoDrawerContext();
  const { activeFile } = usePaymentDetail();
  const [fileName, setFileName] = useState('');

  const handleFileNameLoaded = useCallback((name: string) => {
    setFileName(name);
  }, []);

  const businessDocumentId =
    activeFile?.type === ActiveFileType.BUSINESS_DOCUMENT
      ? activeFile.id
      : undefined;

  return (
    <FileInfoDrawerContainer title={fileName}>
      {open && businessDocumentId ? (
        <Suspense fallback={<FallbackLoading />}>
          {children({
            businessDocumentId,
            onFileNameLoaded: handleFileNameLoaded,
          })}
        </Suspense>
      ) : null}
    </FileInfoDrawerContainer>
  );
};
BusinessDocumentDrawerShell.displayName = 'BusinessDocumentDrawerShell';
